"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactCallToAction() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>();
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="4554" id="contactcalltoaction" className="text-foreground relative overflow-hidden bg-primary">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="h-[900px] w-[900px] max-w-[140%] rounded-lg" style={{
        background: "radial-gradient(circle at center, hsla(210, 90%, 50%, 0.15) 0%, hsla(210, 90%, 50%, 0.08) 30%, hsla(210, 90%, 50%, 0.02) 55%, transparent 75%)",
        filter: "blur(20px)"
      }} />
      </div>

      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "linear-gradient(var(--foreground) 1px, transparent 1px), linear-gradient(90deg, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "60px 60px"
    }} />

      <div className="relative mx-auto max-w-5xl px-6 py-24 sm:py-32 md:py-40 lg:py-[200px]">
        {}
        <div ref={eyebrowRef} className={`flex items-center justify-center gap-3 transition-all duration-700 ease-out ${eyebrowVisible ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"}`}>
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-lg opacity-75" style={{
            backgroundColor: "var(--primary)"
          }} />
            <span className="relative inline-flex h-2 w-2 rounded-lg" style={{
            backgroundColor: "var(--primary)"
          }} />
          </span>
          <span className="font-default text-[11px] uppercase tracking-[0.25em] text-primary-foreground">
            Serving Lakeland & Polk County
          </span>
        </div>

        {}
        <h2 ref={headlineRef} className="mt-10 text-center font-default font-bold transition-all duration-1000 ease-out translate-y-0 opacity-100 text-primary-foreground" style={{
        fontSize: "clamp(2.5rem, 8vw, 5rem)",
        lineHeight: 1.1,
        letterSpacing: "-0.02em"
      }}>
          Ready to Request a Bathroom Remodel Quote
          <span style={{
          color: "var(--primary)"
        }}>?</span>
        </h2>

        {}
        <p ref={bodyRef} className="mx-auto mt-8 max-w-2xl text-center text-lg sm:text-xl leading-relaxed font-default transition-all duration-1000 delay-100 ease-out translate-y-0 opacity-100 text-primary-foreground">
          Request a free bathroom remodel quote in Lakeland, FL and review next steps for your project. Submit the form to get started.
        </p>

        {}
        <div ref={ctaRef} className={`mt-12 flex flex-col items-center justify-center gap-5 sm:flex-row sm:gap-8 transition-all duration-1000 delay-200 ease-out ${ctaVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <Button asChild size="lg" className="group h-12 px-7 font-default text-[14px] font-semibold uppercase tracking-[0.05em] shadow-md rounded-lg">
            <Link to="/Contact">
              <span>Get a Free Quote</span>
              <ArrowRight className="size-4 transition-transform duration-300 ease-out group-hover:translate-x-1" />
            </Link>
          </Button>

          <Link to="/Services" className="group relative inline-flex items-center font-default text-sm text-foreground">
            <span className="relative pb-1 !text-[rgba(253,254,255,1)]">
              View Our Services
              <span aria-hidden="true" className="absolute bottom-0 left-0 h-px w-full origin-left scale-x-100 bg-foreground/40 transition-transform duration-300 ease-out group-hover:scale-x-0" />
              <span aria-hidden="true" className="absolute bottom-0 left-0 h-px w-full origin-right scale-x-0 transition-transform duration-300 ease-out delay-150 group-hover:origin-left group-hover:scale-x-100" style={{
              backgroundColor: "var(--primary)"
            }} />
            </span>
          </Link>
        </div>

        {}
        <div ref={footerRef} className={`mt-24 sm:mt-32 transition-all duration-1000 delay-300 ease-out ${footerVisible ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"}`}>
          <div className="flex items-center gap-4 sm:gap-6">
            <Separator className="flex-1 bg-border/60" />
            <span className="font-default text-[10px] uppercase tracking-[0.2em] whitespace-nowrap text-primary-foreground">
              Lakeland Bathroom Remodel Pros — Serving Polk County
            </span>
            <Separator className="flex-1 bg-border/60" />
          </div>
        </div>
      </div>
    </section>;
}